import React, { Component } from "react";
import { withRouter, Link} from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, saveState, deleteState } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import {getMessagemErro} from "../../utils/erro";
import { ConfirmModal } from "../ConfirmModal/ConfirmModal";
import { Pagination } from "../Pagination/Pagination";
import { ButtonBack } from "../Button/Back";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import api from "../../services/api";
import './ManagerProfile.css';

const mapDispatchToProps = { saveState, deleteState, exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		filters: state.filterStore,
	}
}

export const ManagerProfileList =

// router
withRouter(
// redux
connect(
	(mapStateToProps),
	(mapDispatchToProps)
)(
	class extends Component {
	
		constructor(props){
			super(props);
			this.initialState = {
				resultadoPesquisa: [],
				perfisOrgao: [],
				perfilOrgao: "",
				nome: "",
				ativos: true,
				pesquisaExecutada: false,
				exibeModalAtivar: false,
				exibeModalInativar: false,
				botoesHabilitados : true,
			};

			this.state = this.initialState;
			this.handleInputChange = this.handleInputChange.bind(this);
			this.pesquisar = this.pesquisar.bind(this);
			this.executaPesquisaPaginada = this.executaPesquisaPaginada.bind(this);
			this.limparPesquisa = this.limparPesquisa.bind(this);

			this.confirmaOperacao = this.confirmaOperacao.bind(this);
			this.fechaModais = this.fechaModais.bind(this);
			this.handleOkModais = this.handleOkModais.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					
					<div style={{margin: "10px"}}>
						<h1>Perfis de Gestor</h1>
					</div>
					
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();

			api.get('/api/perfil-orgao')
			.then(response => { this.setState({perfisOrgao: response.data}) })
			.catch(erro => {
				console.log("Não foi possível recuperar os perfis de órgão.", erro)
				this.props.exibeMensagemErro("Erro durante o carregamento da página")
			});

			if (!this.props.location.state?.resetSearch) {
				this.executarPesquisaAnterior();
			}
		}

		renderForm() {
			const { resultadoPesquisa, pesquisaExecutada, ativos } = this.state;
			const { content } = resultadoPesquisa;

			return(
				<div className="container-fluid">

					<ConfirmModal titulo="Confirmação" 
						visible={this.state.exibeModalAtivar}
						handleOk={() => this.handleOkModais()}
						handleCancel={() => this.fechaModais()}
						message="Deseja realmente habilitar o perfil de gestor?"/>

					<ConfirmModal titulo="Confirmação" 
						visible={this.state.exibeModalInativar}
						handleOk={() => this.handleOkModais()}
						handleCancel={() => this.fechaModais()}
						message="Deseja realmente desabilitar o perfil de gestor?"/>

					<div className="br-form">
						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
									<label>Perfil do Órgão:</label>
										<SelectSearch
											id="perfilOrgao"
											name="perfilOrgao"
											includeAllOption={true}
											options={this.state.perfisOrgao.map(perfilOrgao => ({value: perfilOrgao.id, label: perfilOrgao.nome}))}
											onChange={this.handleInputChange}
											value={this.state.perfilOrgao}
										/>
									</div>
								</div>
							</div>
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="nome">Nome:</label>
										<input type="text" name="nome" 
											value={this.state.nome}  
											onChange={this.handleInputChange} 
											maxLength="100"/>
									</div>
								</div>
							</div>
							<div className="col-sm-2">
								<div className="field">
									<div className="input">
										<label htmlFor="consumidora">Situação:</label>
										<SelectSearch
											id="ativos"
											name="ativos"
											includeAllOption={true}
											options={[{value: true, label: 'Ativos'}, {value: false, label: 'Inativos'}]}
											onChange={this.handleInputChange}
											value={ativos}
										/>
									</div>
								</div>
							</div>
						</div>

						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={() => this.pesquisar()} disabled={!this.state.botoesHabilitados}>Pesquisar</button>
								<button type="button" className="button is-secondary" onClick={() => this.limparPesquisa()} disabled={!this.state.botoesHabilitados}>Limpar</button>
								<Link to="/manager-profile/new"> 
									<button type="button" className="button is-secondary mr-3" disabled={!this.state.botoesHabilitados}>Novo</button>
								</Link>
								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>
					
						{(content && content.length > 0) &&	
							<div className="br-table">						
								<div className="table">
									<table>
										<thead>
											<tr>
											<th scope="col">Perfil Órgão</th>
											<th scope="col">Nome</th>
											<th scope="col">Transações</th>
											<th className="text-center" scope="col">Ações</th>
											</tr>
										</thead>
										
										<tbody>
											{ content.map((perfilGestor, index) =>
													<tr key={index} >
														<td>{perfilGestor.nomePerfilOrgao}</td>
														<td>{perfilGestor.nome}</td>
														<td>
															{(perfilGestor.transacoes && perfilGestor.transacoes.length > 0) && 
																<ul>{perfilGestor.transacoes.sort((pot1, pot2)=> pot1.nomeTransacao.localeCompare(pot2.nomeTransacao)).map(pot => <li>{pot.nomeTransacao}</li>)}</ul>}
														</td>

														<td className="text-center">
															<div className="actions">
																{ perfilGestor.mutavel &&
																	<Link to={`/manager-profile/edit/${perfilGestor.id}`}>
																		<button type="button" disabled={!this.state.botoesHabilitados} title="Editar o perfil de gestor">
																			<span className="sr-only">Editar</span>
																			<i className="fas fa-edit"></i>
																		</button>
																	</Link>
																}

																{ perfilGestor.ativo === true && perfilGestor.mutavel &&
																	<button type="button" onClick={() => this.confirmaOperacao(perfilGestor)} disabled={!this.state.botoesHabilitados} title="Desabilitar o perfil de gestor">
																		<span className="sr-only">Desativar</span>
																		<i className="fas fa-power-off" id="on"></i>
																	</button>
																}
																
																{  perfilGestor.ativo === false && perfilGestor.mutavel &&
																	<button type="button" onClick={() => this.confirmaOperacao(perfilGestor)} disabled={!this.state.botoesHabilitados} title="Habilitar o perfil de gestor">
																		<span className="sr-only">Ativar</span>
																		<i className="fas fa-power-off" id="off"></i>
																	</button>
																}
															</div>
														</td>
													</tr>
												)}
										</tbody>
									</table>
									<Pagination totalPaginas={resultadoPesquisa.totalPages} paginaAtual={resultadoPesquisa.number} onChangePage={this.executaPesquisaPaginada}/>
								</div>
							</div>
						}

						{(pesquisaExecutada && (! content || content.length === 0)) &&
							<div>
								Nenhum perfil de gestor encontrado com os critérios informados.
							</div>
						}
					</div>
				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;
			this.setState({[nome]: valor});
		}

		executarPesquisaAnterior() {
			const lastState = this.props.filters[this.props.location.pathname];

			this.setState({
				...this.initialState,
				...lastState,
				pesquisaExecutada: false,
				resultadoPesquisa: []
			}, () => {
				if (lastState) {
					const lastPage = lastState ? lastState?.resultadoPesquisa?.number : 0;
					this.executaPesquisaPaginada(lastPage);
				}
			});
		}

		pesquisar (e){
			this.props.limpaMensagem();
			this.executaPesquisaPaginada(0);
			if (this.props.location.state?.resetSearch) {
				this.props.history.replace(this.props.location.pathname, {
					...this.props.location.state,
					resetSearch: false,
				  });
			}
		}

		executaPesquisaPaginada (pagina){

			const {perfilOrgao, nome, ativos} = this.state;
			const criterioPesquisa = {perfilOrgao, nome, ativos, pagina};
			const url = '/api/perfil-gestor/paginado';

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa
			}

			this.props.mostraAguardando();
			api(options)
				.then(response => { 
					this.setState({
						resultadoPesquisa: response.data,
						pesquisaExecutada : true,
					}, () => {
						this.props.saveState(this.state, this.props.location.pathname);
					}) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar os Perfis de Gestor. ", erro)
					this.props.exibeMensagemErro("Erro durante a execução da pesquisa")
				})
				.then(() => {
					this.props.escondeAguardando();
				});
		}

		limparPesquisa(){
			this.setState(
				{
					resultadoPesquisa: [],
					perfilOrgao: '',
					nome: '',
					ativos: true,
					pesquisaExecutada: false,
					exibeModalAtivar: false,
					exibeModalInativar: false,
					botoesHabilitados : true
				}, () => {
					this.props.deleteState(this.state, this.props.location.pathname);
				}
			);
		}

		alterarSituacao (perfilGestor){
			const body = { ativo: !perfilGestor.ativo }
			this.setState({botoesHabilitados:false});
			this.props.limpaMensagem();
			this.props.mostraAguardando();
			window.scrollTo(0, 0)

			api.put(`/api/perfil-gestor/situacao/${perfilGestor.id}`, body)
				.then(response => { 
					this.setState({
						pesquisaExecutada : true,
					}) 
					this.pesquisar();
					let mensagem = perfilGestor.ativo === true ? 'Perfil de Gestor desabilitado com sucesso!' : 'Perfil de Gestor habilitado com sucesso!';
					this.props.exibeMensagemSucesso(mensagem);
				})
				.catch(erro => {
					const mensagemInicial = `Não foi possível ${perfilGestor.ativo === true ? 'desativar' : 'ativar'} o perfil de gestor.`;
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.setState({botoesHabilitados:true});
					this.props.escondeAguardando();
				});
		}

		handleOkModais () {
			this.alterarSituacao(this.state.perfilGestorAlvo);
			this.fechaModais();
		}

		confirmaOperacao(perfilGestor) {
			this.setState(
				{
					exibeModalAtivar: perfilGestor.ativo === false,
					exibeModalInativar: perfilGestor.ativo === true,
					perfilGestorAlvo: perfilGestor,
				}
			);
		}

		fechaModais () {
			this.setState(
				{
					exibeModalAtivar:false,
					exibeModalInativar:false
				}
			);
		}
	}

) // redux
); // router